<template>
    <v-col cols="12" class="ProfileCompany mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" md="6" >
                <v-card 
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                   <v-card-title class="headline pt-0 mx-auto justify-left">
                    <h2 class="font-weight-medium text-center font-family-1 font-size-30">Perfil de Empresa </h2>
                </v-card-title>
                <v-card-text>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Seleccione una Empresa</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['NEOCITY ENERGÍA']"
                                    label="Seleccione una Empresa"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 elevation-0 border-1"
                                    tile
                                    height="160px"
                                    width="160px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="140px"
                                       width="140px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                             <v-row class="px-3">
                                <v-col class="pa-0" cols="4">
                                    <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Rut de la Empresa</v-subheader>
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                    <v-text-field
                                            dense
                                            placeholder="00.000.000-0"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="px-3">
                                <v-col class="pa-0" cols="4">
                                    <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Razon Social</v-subheader>
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                    <v-text-field
                                            placeholder="Razon Social Empresa"
                                            dense

                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Región de Retiro (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                          <v-select
                                    :items="['Metropolitana']"
                                    placeholder="Selecciona la región de retiro"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Comuna de Retiro (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                             <v-select
                                    :items="['Las Condes']"
                                    placeholder="Selecciona la comuna de retiro"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Giro Comercial (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Giro Empresa"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Direccion Comercial (*)
                            </v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Calle #000, Comuna, Region, Pais"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Representante Legal (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Nombre Apellido"
                                    dense
                                    @click="dialog.show = true"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1 " style="height: 27px; ">Correo Electronico (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="info@neocity.cl"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Teléfono</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="+56 2 2222 2222"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-5 px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Sitio Web</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="www.neocity.cl"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                              <v-textarea
                                name="Description"
                                outlined
                                label="Description"
                                auto-grow
                                value="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pulvinar massa ut eros sagittis, in pharetra massa posuere. Cras lectus ante, sodales at mi non, placerat euismod mauris. Quisque luctus facilisis lectus, ac porta ipsum semper sit amet. Sed eget fermentum metus, sed bibendum orci. Vestibulum at convallis sem. Vestibulum posuere neque ut lectus aliquet volutpat. Integer sed tincidunt velit. Etiam tristique enim sit amet purus iaculis, vitae lacinia dolor auctor."
                                ></v-textarea>
                        </v-col>
                    </v-row>
                      <v-row>
                        <v-col>
                              <v-file-input label="Seleccionar archivo PDF" outlined dense></v-file-input>
                        </v-col>
                    </v-row>
                <v-divider></v-divider>
                </v-card-text>
                    <v-btn color="primary"
                           raised
                           dark
                           @click="dialog.sendData.show = true"
                           class="pa-6">Guardar</v-btn>

                </v-card>

            </v-col>
            <v-col cols="12" md="6" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <v-row  align="center"
                            justify="left" class="">
                        <v-col cols="12">
                            <v-row>
                                <v-col>
                                    <h2 class="font-weight-medium">Análisis (Recomendación de compra)</h2>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="text-left">
                            <v-carousel
                                    cycle
                                    height="200px"
                                    hide-delimiter-background
                            >
                                <v-carousel-item
                                    v-for="(item,i) in 2"
                                    :key="i"
                                    >
                                        <v-row>
                                            <v-col>
                                                <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="180px">
                                                    <h3 class="grey--text">Grafico {{1+(i)}}</h3>
                                                </v-card>
                                            </v-col>

                                            <v-col>
                                            
                                                <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="180px">
                                                    <h3 class="grey--text">Grafico {{2+(i+1)}}</h3>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                </v-carousel-item>
                            </v-carousel>
                        </v-col>
                      
                    </v-row>

                    <v-row align="center"
                           justify="left" class="">
                        <v-col cols="12">
                            <v-row>
                                <v-col>
                                    <h2 class="font-weight-medium">Puntos de Retiro</h2>
                                </v-col>
                            </v-row>
                             <v-btn color="primary"
                               raised
                               dark
                               to="/system/consumer/withdrawal-points"
                               class="px-6">12 Puntos de Retiro</v-btn>
                        </v-col>
                        <v-col cols="12" class="text-left">
                           <v-row>
                                <v-col>
                                    <h2 class="font-weight-medium">Contatos y Documentos</h2>
                                </v-col>
                            </v-row>
                             <v-data-table
                                        :headers="contracts.headers"
                                        :items="contracts.data"
                                        :items-per-page="5"
                                        item-key="code"
                                        class="elevation-1"
                                        :search="contracts.search"
                                        dense
                                        show-select
                                        :item-class="classColorReturn"
                                >

                                    <template v-slot:item.TimeBlocks="{ item }">
                                        <v-col class="d-inline-flex">
                                            <v-chip v-for="(block,key) in item.TimeBlocks"
                                                    class="ma-1"
                                                    :color="block === 'A' ? '#004E85': block === 'B' ? '#FF9A1B' : block === 'C' ? '#0172C0' : 'grey'  "
                                                    label
                                                    dense
                                                    :key="item.code+'-'+key"
                                                    small
                                                    text-color="white"
                                            >
                                                {{block}}
                                            </v-chip>
                                        </v-col>
                                    </template>
                                    
                                    <template v-slot:item.Contract="{ item }">
                                        <v-btn
                                                outlined
                                            raised
                                            :color="item.Contract.color"
                                            small
                                            dark
                                            class="">{{item.Contract.text}}</v-btn>
                                    </template>

                                </v-data-table>
                        </v-col>
                        
                    </v-row>

                </v-card>
            </v-col>
        </v-row>
        <v-dialog
                v-model="dialog.show"
                width="70%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Validar Representante Legal
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fringilla lacus vel porta vestibulum. Pellentesque varius, arcu vitae ornare posuere, ligula nulla interdum dolor</p>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-file-input label="Seleccionar archivo PDF" outlined dense></v-file-input>
                            <p class="caption">El archivo no debe superar los 10mb</p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            outlined
                            class="px-6"
                            @click="dialog.show = false"
                    >
                        Ver mas Tarde
                    </v-btn>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.show = false"
                    >
                        Cargar El Documento
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialog.sendData.show"
                width="70%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Tu información ha sido enviada
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Hemos enviado toda tu infomacion al equipo de validación. Revisaremos tu información esté correcta y te enviaremos el link para que puedas completar tu registro y comenzar a ofertar enería</p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.sendData.show = false"
                    >
                        Volver al Inicio
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialog.offerCreated.show"
                width="450px"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Tu oferta fue creada
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Hemos creado tu oferta. Ahora la podras ver en tu perfil.</p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.offerCreated.show = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>

</template>
<script>
    export default {
        name: 'ProfileCompany',
        data() {
            return {
                crateOffersEnergy: false,
                dialog: {
                    show: false,
                    sendData:{ show:false },
                    offerCreated:{ show:false },
                },
                 contracts:{
                    search:'',
                    headers: [
                        { text: 'Expira el', value: 'expire' },
                        { text: 'Suministrador', value: 'supplier' },
                        { text: 'Tipo de EnergÍA', value: 'TypeOfEnergy' },
                        { text: 'Tipo de Documento', value: 'TypeOfContract' },
                        { text: 'Bloques Horarios', value: 'TimeBlocks' },
                        { text: 'ver', value: 'Contract' },

                    ],
                    data: [
                        {
                            color:'',
                            expire: '10-03-2020',
                            supplier: 'San Andres SpA',
                            TypeOfEnergy: 'Solar',
                            TypeOfContract: 'Contrato',
                            TimeBlocks:['A','B','C'],
                            Contract: {
                                color:'grey',
                                text:'Ver'
                            }
                        },
                        {
                            color:'',
                            expire: '10-03-2020',
                            supplier: 'San Andres SpA',
                            TypeOfEnergy: 'Solar',
                            TypeOfContract: 'Contrato',
                            TimeBlocks:['A','B','C'],
                            Contract: {
                                color:'grey',
                                text:'Ver'
                            }
                        }, 
                        {
                            color:'',
                            expire: '10-03-2020',
                            supplier: 'San Andres SpA',
                            TypeOfEnergy: 'Solar',
                            TypeOfContract: 'Factura',
                            TimeBlocks:['A','C'],
                            Contract: {
                                color:'grey',
                                text:'Ver'
                            }
                        }, 
                        {
                            color:'',
                            expire: '10-03-2020',
                            supplier: 'San Andres SpA',
                            TypeOfEnergy: 'Solar',
                            TypeOfContract: 'Mandato Ofertas',
                            TimeBlocks:['A','B',],
                            Contract: {
                                color:'grey',
                                text:'Ver'
                            }
                        }, 
                        {
                            color:'',
                            expire: '10-03-2020',
                            supplier: 'San Andres SpA',
                            TypeOfEnergy: 'Solar',
                            TypeOfContract: 'Contrato',
                            TimeBlocks:['A','B','C'],
                            Contract: {
                                color:'grey',
                                text:'Ver'
                            }
                        },
                    ]
                }


            }
        },
        created: function () {
            this.$emit('SetcolorMenu', '#FE9A00');
        }
    }
</script>